"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _lodash = require("lodash");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var AuthenticateStore = /*#__PURE__*/function (_RootStore) {
  function AuthenticateStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, AuthenticateStore);
    _this = _callSuper(this, AuthenticateStore);
    _this.redirectRouteNameAfterLogin = null;
    _this.config = {
      prefix: '/user',
      POST: {
        signIn: '/authentications',
        signInAsGuest: '/authentications/create_guest',
        findFromFacebook: 'authentications/find_from_facebook',
        findFromApple: 'authentications/find_from_apple',
        register: '/',
        convertGuest: '/authentications/convert_guest',
        sendConfirmationInstructions: '/authentications/send_confirmation_instructions',
        validateEmailConfirmationToken: '/authentications/validate_email_confirmation_token',
        sendResetPasswordInstructions: '/authentications/send_reset_password_instructions',
        signOut: '/authentications/user_sign_out',
        redirectAfterLogin: '/authentications/redirect_after_login',
        signInWithAppleAuthorization: '/authentications/sign_in_with_apple_authorization'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(AuthenticateStore, _RootStore);
  return (0, _createClass2["default"])(AuthenticateStore, [{
    key: "convertGuest",
    value: function convertGuest(params, callback) {
      this.api(params, callback || _lodash.noop, 'POST', 'convertGuest');
    }
  }, {
    key: "signIn",
    value: function signIn(params, callback) {
      this.api(params, callback || _lodash.noop, 'POST', 'signIn');
    }
  }, {
    key: "signOut",
    value: function signOut(params, callback) {
      this.api(params, callback || _lodash.noop, 'POST', 'signOut');
    }
  }, {
    key: "signInAsGuest",
    value: function signInAsGuest(params, callback) {
      this.api(params, callback || _lodash.noop, 'POST', 'signInAsGuest');
    }
  }, {
    key: "findFromFacebook",
    value: function findFromFacebook(params, callback) {
      this.api(params, callback || _lodash.noop, 'POST', 'findFromFacebook');
    }
  }, {
    key: "findFromApple",
    value: function findFromApple(params, callback) {
      this.api(params, callback || _lodash.noop, 'POST', 'findFromApple');
    }
  }, {
    key: "redirectAfterLogin",
    value: function redirectAfterLogin(params, callback) {
      this.api(params, callback || _lodash.noop, 'POST', 'redirectAfterLogin');
    }
  }, {
    key: "register",
    value: function register(params, callback) {
      this.api(params, callback || _lodash.noop, 'POST', 'register');
    }
  }, {
    key: "sendResetPasswordInstructions",
    value: function sendResetPasswordInstructions(params, callback) {
      this.api(params, callback || _lodash.noop, 'POST', 'sendResetPasswordInstructions');
    }
  }, {
    key: "signInWithAppleAuthorization",
    value: function signInWithAppleAuthorization(params, callback) {
      this.api(params, callback || _lodash.noop, 'POST', 'signInWithAppleAuthorization');
    }
  }, {
    key: "sendConfirmationInstructions",
    value: function () {
      var _sendConfirmationInstructions = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var params,
          _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              _context.next = 3;
              return this.apiPromise(params, 'POST', 'sendConfirmationInstructions');
            case 3:
              return _context.abrupt("return", _context.sent);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function sendConfirmationInstructions() {
        return _sendConfirmationInstructions.apply(this, arguments);
      }
      return sendConfirmationInstructions;
    }()
  }, {
    key: "validateEmailConfirmationToken",
    value: function () {
      var _validateEmailConfirmationToken = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var params,
          _args2 = arguments;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              params = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
              _context2.next = 3;
              return this.apiPromise(params, 'POST', 'validateEmailConfirmationToken');
            case 3:
              return _context2.abrupt("return", _context2.sent);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function validateEmailConfirmationToken() {
        return _validateEmailConfirmationToken.apply(this, arguments);
      }
      return validateEmailConfirmationToken;
    }()
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new AuthenticateStore();